module.exports = __webpack_public_path__ + "static/media/icon-horz-scroll-indic.990c8926.svg";